import React, { useState } from 'react';
import { Modal, Icon } from '@scale/scaleui';

interface PreviewMetricsModalProps {
  communicationId: string;
}

export const PreviewMetricsModal: React.FC<PreviewMetricsModalProps> = ({
  communicationId,
}: PreviewMetricsModalProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <>
      <Icon icon="external-link-alt" size="sm" onClick={() => setIsOpen(!isOpen)} />

      <Modal
        open={isOpen}
        onClose={() => setIsOpen(false)}
        title="View SMS Metrics in Redash"
        innerClassName={'w-4/5 h-full'}
      >
        <iframe
          src={`
            https://redash.scale.com/queries/157384?fullscreen&p_sms_communication_id=${encodeURIComponent(
              communicationId,
            )}`}
          width="100%"
          height="100%"
          frameBorder="0"
          className="overflow-hidden"
        />
      </Modal>
    </>
  );
};
